export default __webpack_public_path__ + "static/media/BB_15.a98fc7cf.png";